import { render, staticRenderFns } from "./rpDekstop.vue?vue&type=template&id=7a142f4e"
import script from "./rpDekstop.vue?vue&type=script&lang=js"
export * from "./rpDekstop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports